import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { AlertTriangle, FileCheck, Scale, FileWarning } from "lucide-react";

export default function ResponsabilityWarningDialog({ 
  open, 
  onOpenChange, 
  onConfirm, 
  type = "enterprise", // "enterprise" or "bilan"
  loading = false 
}) {
  const title = type === "enterprise" 
    ? "Déclaration de Responsabilité - Création d'Entreprise"
    : "Déclaration de Responsabilité - Soumission du Bilan Social";

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-lg">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-amber-700">
            <AlertTriangle className="w-6 h-6" />
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-4 text-left">
              <p className="text-slate-700 font-medium">
                En tant que Cabinet habilité par l'Inspection Générale du Travail, je certifie sur l'honneur que :
              </p>
              
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <FileCheck className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                  <span className="text-slate-600">
                    Les informations contenues dans ce document sont <strong className="text-slate-800">exactes, complètes et vérifiables</strong>
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <FileCheck className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                  <span className="text-slate-600">
                    J'ai procédé aux <strong className="text-slate-800">vérifications nécessaires</strong> auprès de l'entreprise concernée
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <FileCheck className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                  <span className="text-slate-600">
                    Je dispose des <strong className="text-slate-800">pièces justificatives</strong> attestant de la véracité des données déclarées
                  </span>
                </li>
              </ul>

              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mt-4">
                <div className="flex items-start gap-2">
                  <Scale className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-red-800 mb-2">
                      Je reconnais que toute fausse déclaration ou omission volontaire est susceptible d'entraîner :
                    </p>
                    <ul className="text-red-700 text-sm space-y-1">
                      <li>• La suspension ou le retrait de mon habilitation</li>
                      <li>• Des poursuites judiciaires conformément à la législation guinéenne en vigueur</li>
                      <li>• L'annulation des déclarations concernées</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-amber-50 border border-amber-300 rounded-lg p-3 flex items-center gap-2">
                <FileWarning className="w-5 h-5 text-amber-600 flex-shrink-0" />
                <p className="text-amber-800 text-sm font-medium">
                  En cliquant sur "Confirmer", j'engage ma responsabilité professionnelle et juridique.
                </p>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-4">
          <AlertDialogCancel disabled={loading}>
            Annuler
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={loading}
            className="bg-primary hover:bg-primary/90"
            data-testid="confirm-responsibility-btn"
          >
            {loading ? "Traitement..." : "Je confirme et j'engage ma responsabilité"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
